module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.grouponDetail != null) ? _c('div', {
    staticClass: "groupon-detail-wrapper"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.shopInfo.name) + " / 团购管理 / " + _vm._s(_vm.grouponDetail.name) + " (" + _vm._s(_vm._f("grouponStatus")(_vm.grouponDetail.status)) + ")")])]), _vm._v(" "), _c('h2', [_vm._v("团购信息")]), _vm._v(" "), _c('table', {
    staticClass: "groupon-detail-table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("名称")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.grouponDetail.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("描述")]), _vm._v(" "), _c('td', _vm._l((_vm.grouponDescriptions), function(desc, index) {
    return _c('div', [(desc.type === 1) ? _c('div', [_c('div', [_vm._v(_vm._s(desc.text))])]) : (desc.type === 2) ? _c('div', {
      staticClass: "groupon-detail-img"
    }, [_c('img', {
      attrs: {
        "src": _vm._f("ossurl")(desc.text),
        "alt": ""
      }
    })]) : _vm._e()])
  }), 0)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("开始时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeFormatter")(_vm.grouponDetail.start_time, 'yyyy-MM-dd')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("开始时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dateTimeFormatter")(_vm.grouponDetail.end_time, 'yyyy-MM-dd')))])]), _vm._v(" "), _vm._l((_vm.grouponDetail.products), function(product, index) {
    return _c('tr', [_c('td', [_vm._v("商品名称" + _vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.name))])])
  })], 2)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', {
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v("报名信息")]), _vm._v(" "), _c('el-tag', [_vm._v("共有" + _vm._s(_vm.grouponEnrolls.length) + "参与了团购")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.smsDialogVisible = true
      }
    }
  }, [_vm._v("(群发短信)")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "群发短信",
      "visible": _vm.smsDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.smsDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "smsDialogForm",
    attrs: {
      "model": _vm.smsDialogForm,
      "rules": _vm.smsDialogRules,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "短信内容",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.smsDialogForm.content),
      callback: function($$v) {
        _vm.$set(_vm.smsDialogForm, "content", $$v)
      },
      expression: "smsDialogForm.content"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.cancelSendGrouponSms('smsDialogForm')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendGrouponSms('smsDialogForm')
      }
    }
  }, [_vm._v("发 送")])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "data": _vm.grouponEnrolls,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.summaryData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.enroll_order) + "\n      ")]
      }
    }], null, false, 3900454650)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "align": "center",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.user.name) + "\n      ")]
      }
    }], null, false, 447776549)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "电话",
      "align": "center",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "comment",
      "align": "center",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "align": "center",
      "label": "地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "团购商品"
    }
  }, _vm._l((_vm.grouponDetail.products), function(product, index) {
    return _c('el-table-column', {
      key: product.id,
      attrs: {
        "label": product.name,
        "align": "center",
        "column-key": product.id.toString()
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n            " + _vm._s(_vm._f("getAmount")(scope.column.columnKey, scope.row)) + "\n          ")]
        }
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm._f("getMoney")(scope.row)) + "\n      ")]
      }
    }], null, false, 3836078732)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.currentPageChanged,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cf206fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/groupon-detail.vue
// module id = 799
// module chunks = 1